import { render, staticRenderFns } from "./SearchItemInfo.vue?vue&type=template&id=5fc1ef59&scoped=true&"
import script from "./SearchItemInfo.vue?vue&type=script&lang=js&"
export * from "./SearchItemInfo.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemInfo.vue?vue&type=style&index=0&id=5fc1ef59&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1ef59",
  null
  
)

export default component.exports